<template>
  <p class="subtitle">
    <slot />
    <a-tooltip v-if="tooltip">
      <template title>
        <span> {{ tooltip }} </span>
      </template>
      <InfoCircleOutlined />
    </a-tooltip>
  </p>
</template>

<script>
import { InfoCircleOutlined } from "@ant-design/icons-vue";
export default {
  components: {
    InfoCircleOutlined,
  },
  props: {
    tooltip: {
      required: false,
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="sass" scoped>
.subtitle
  color: $gray-9
  font-weight: 600
  margin: 16px 0 8px 0
</style>
